import React from "react";
export default (function () {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon",
    viewBox: "0 0 37 30",
    style: {
      height: "1em",
      width: "1.23333em"
    }
  }, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    transform: "translate(8.515 5.12)"
  }, React.createElement("rect", {
    width: "18.75",
    height: "18.75",
    x: ".625",
    y: ".625",
    rx: "1.5"
  }), React.createElement("path", {
    d: "M4.375,14.375 L7.26,10.5283333 C7.47737303,10.2383071 7.8099288,10.0569103 8.17145821,10.0311667 C8.53298762,10.0054231 8.88789122,10.1378677 9.14416667,10.3941667 L10,11.25 L12.75,7.58333333 C12.986068,7.26857603 13.3565534,7.08333333 13.75,7.08333333 C14.1434466,7.08333333 14.513932,7.26857603 14.75,7.58333333 L16.975,10.55"
  }), React.createElement("circle", {
    cx: "5.313",
    cy: "5.313",
    r: "1.563"
  }), React.createElement("path", {
    d: "M0.625,14.375 L19.375,14.375"
  }))));
});